$(function () {
    $('.hindle-home-banner .items').uniformify({
        selector: '.caption',
        bottom: true
    });
});
